export const fallbackNotes = ["C4", "D4", "E4", "G4", "A4", "C5"];

export const keyboardMap: Record<string, string> = {
  a: "C4",
  s: "D4",
  d: "E4",
  f: "G4",
  j: "A4",
  k: "C5",
  l: "D5",
  ";": "E5"
};

const noteOffsets: Record<string, number> = {
  C: -9,
  "C#": -8,
  Db: -8,
  D: -7,
  "D#": -6,
  Eb: -6,
  E: -5,
  F: -4,
  "F#": -3,
  Gb: -3,
  G: -2,
  "G#": -1,
  Ab: -1,
  A: 0,
  "A#": 1,
  Bb: 1,
  B: 2
};

export function noteNameToFrequency(noteName: string): number {
  const match = /^([A-G](?:#|b)?)(-?\d+)$/.exec(noteName);

  if (!match) {
    return 440;
  }

  const [, pitchClass, octaveText] = match;
  const octave = Number(octaveText);
  const semitonesFromA4 = noteOffsets[pitchClass] + (octave - 4) * 12;

  return 440 * 2 ** (semitonesFromA4 / 12);
}

export function centsToRate(cents: number): number {
  return 2 ** (cents / 1200);
}
